// Centralised share helpers + production share URL. Update SHARE_URL here if
// the marketing domain ever changes and every share surface picks it up.
export const SHARE_URL = "https://hypergains.fit";
export const SHARE_HASHTAGS = "Hypergains,MechanicalTension,NoFluff";

export function buildShareText(rank, totalExp) {
    const exp = typeof totalExp === "number" ? ` · ${totalExp.toLocaleString()} EXP banked` : "";
    return `Just hit ${rank.name} rank on Hypergains${exp}. Evidence-based training, no fluff. Find out where you stand:`;
}

// Public share-intent URLs. Each platform handles the URL differently — some
// honour `text`, others ignore it. We keep them lean and predictable.
export function intentUrls({ text, url }) {
    const u = encodeURIComponent(url);
    const t = encodeURIComponent(text);
    return {
        x: `https://twitter.com/intent/tweet?text=${t}&url=${u}&hashtags=${encodeURIComponent(SHARE_HASHTAGS)}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}&quote=${t}`,
        // Facebook Messenger deep-link — opens the FB Messenger app on mobile
        // (the most common Messenger surface). On desktop the click typically
        // does nothing; the desktop fallback for chat is the FB share dialog
        // which lets the user pick "Send in Messenger" themselves.
        messenger: `fb-messenger://share?link=${u}`,
        reddit: `https://www.reddit.com/submit?url=${u}&title=${t}`,
        whatsapp: `https://api.whatsapp.com/send?text=${t}%20${u}`,
        telegram: `https://t.me/share/url?url=${u}&text=${t}`,
    };
}

// Try to share an image File via the native share sheet. Falls back to text+url
// share, then to clipboard copy. Returns "files" | "text" | "copy" | "cancel" | "unavailable".
export async function nativeShare({ file, text, url }) {
    if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
        try {
            await navigator.share({ files: [file], text, url });
            return "files";
        } catch (e) {
            if (e?.name === "AbortError") return "cancel";
        }
    }
    if (navigator.share) {
        try {
            await navigator.share({ text, url });
            return "text";
        } catch (e) {
            if (e?.name === "AbortError") return "cancel";
        }
    }
    try {
        await navigator.clipboard.writeText(`${text} ${url}`);
        return "copy";
    } catch (e) {
        return "unavailable";
    }
}

// Some browsers (Safari Desktop) report navigator.share but reject file
// payloads silently — keep a lightweight check the caller can use to render
// the popover instead.
export function hasNativeShare() {
    return typeof navigator !== "undefined" && typeof navigator.share === "function";
}
